module.exports = __webpack_public_path__ + "img/browser-chrome-logo.b068b646.webp";